import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-language-translation',
  templateUrl: './language-translation.component.html',
  styleUrls: ['./language-translation.component.scss']
})
export class LanguageTranslationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
